import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { AutomacaoVendaSalvarRequest } from '../../requests/vendas/automacao-venda-salvar.request';
import { GetAutomacaoVendaResponse } from '../../responses/vendas/get-automacao-venda.response';
import { SalvarAutomacaoVendaResponse } from '../../responses/vendas/salvar-automacao-venda.response';

@Injectable({
  providedIn: 'root',
})
export class AutomacaoVendaService extends CommonService {
  private readonly apiUrl: string = environment.urlApiVendas + 'AutomacaoVenda';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public get(): Observable<GetAutomacaoVendaResponse> {
    return this.httpClient
      .get<GetAutomacaoVendaResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvar(request: AutomacaoVendaSalvarRequest): Observable<SalvarAutomacaoVendaResponse> {
    return this.httpClient
      .put<SalvarAutomacaoVendaResponse>(`${this.apiUrl}/salvar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
